import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2raaesf5hr: FaireBrandEntity = {
  token: "b_2raaesf5hr",
  type: "brand",
  name: "Hair Dance",
  avatarUrl:
    "https://cdn.faire.com/fastly/f1927928c96d0c14ab9dca3219ad12029a7170efc57afb6733f6e0871d2e0d25.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/edbbc20c6e85d0686df31d7b63fe50d5715350ef5efe1256107081cc2ca0d66f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f1927928c96d0c14ab9dca3219ad12029a7170efc57afb6733f6e0871d2e0d25.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/edbbc20c6e85d0686df31d7b63fe50d5715350ef5efe1256107081cc2ca0d66f.jpeg",
  location: "Loudon, TN, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 7,
  isInsider: true,
  description:
    "By purchasing from us on Faire, you acknowledge that you are not authorized to resell our products on Amazon. We thank you for your understanding.\n\nHair Dance is committed to solving your hair concerns without sacrificing the integrity of our ingredients. We formulate our products with your scalp and hair health in mind - and that’s why we will never use parabens, silicones, phtalates, DEA, artificial dyes, synthetic fragrances, and sulfates. Our products are expertly formulated and made in the USA and we never test on animals. \n\nMany mainstream hair products are designed to give you instant gratification by coating your hair with toxic chemicals. Our products are designed to strengthen and restore healthy hair by providing solutions for life.  \n\nWe hope that when you see the long-term results delivered by our products, that you, too, can feel your hair doing its own happy dance from within.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:08.792Z",
    importedBy: "entity-db-cli",
  },
};
